import React from 'react';

const ClientsHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Clients
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Clients page allows partners to manage their client organizations.
          View client details, subscription status, and access client-specific
          settings and data.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Client List
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View all your client organizations:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Name:</strong> Client organization name</li>
          <li><strong>Contact:</strong> Primary contact email</li>
          <li><strong>Projects:</strong> Number of active projects</li>
          <li><strong>Subscription:</strong> Current plan and status</li>
          <li><strong>Created:</strong> When the client was onboarded</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Adding New Clients
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          To add a new client organization:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>Click the "Add Client" button</li>
          <li>Enter the client organization name</li>
          <li>Provide contact person details</li>
          <li>Select subscription plan</li>
          <li>Optionally create a user account for the client</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Subscription Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Manage client subscriptions:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Active:</strong> Client has an active subscription</li>
          <li><strong>Trial:</strong> Client is in trial period</li>
          <li><strong>Expired:</strong> Subscription needs renewal</li>
          <li><strong>Cancelled:</strong> Subscription has been cancelled</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Client Context
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Use the client selector in the top navigation to switch context and view
          data specific to a particular client. This affects dashboards, projects,
          and other client-specific information throughout the platform.
        </p>
      </div>

    </>
  );
};

export default ClientsHelp;
